<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<div class="simple-keyboard"></div>
